import config from 'configDir/index';
import { put, putQuery, get } from './http';

const loginService = put('/login/login', config.userCenterServiceUrl);
const loginOutService = putQuery('/login/logout', config.userCenterServiceUrl);

// 查询配置信息
const getConfig = get('/enconfig/getEnableConfig', config.commonServiceUrl);

// 查询报警违章类目
const getAlarmViolationCategory = get('/category/list/all', config.governanceUrl);

const getCategoryService = get('/enums/rule/getRuleTypeEnum', config.commonServiceUrl);

export { loginService, loginOutService, getConfig, getAlarmViolationCategory, getCategoryService };
